$(document).on('click', '.rd-header', function() {
  var this_ = $(this);
  console.log('asd');
  this_.siblings('.rd-ul').slideToggle(300);
});
$(document).on('click', '.rd-ul a', function() {
  var thisEle = $(this);
  var thisVal = thisEle.text();
  var thisIndex = thisEle.parents('li').index();
  thisEle.parents('.repairDropdown').find('.rd-header').text(thisVal);
  thisEle.parents('.rd-ul').slideUp(300);
  $('.finderInput input').val('');
  if(thisEle.parents('.repairDropdown').siblings('.finderInput:visible').length < 1) {
    thisEle.parents('.repairDropdown').siblings('.finderInput').slideDown(300);
  }
  if(thisEle.parents('.finderWrap').find('.finderBtnWrap:visible').length < 1) {
    thisEle.parents('.finderWrap').find('.finderBtnWrap').slideDown(300);
  }
  thisEle.parents('.repairDropdown').siblings('.finderInput').find('.finderVal').eq(thisIndex).show().siblings('.finderVal').hide();
});

$(document).on('click', function(e) {
  if(!$(e.target).parents('div').hasClass('finderWrap')) {
    if($('.repairDropdown .rd-ul:visible').length > 0) {
      $('.rd-header').click();
    }
  }
});

$(document).on('click', '.finderSubmit', function() {
  var VisiInpVal =  $(this).parents('.finderWrap').find('input:visible').val();
  var numberVal = $('#numberfinder').val();
  var emailVal = $('#emailfinder').val();
  var phoneVal = $('#phfinder').val();
  $('.fr-header .fr-error').remove();

  if(numberVal === '' && emailVal === '' && phoneVal === ''){
    $('.finderResult').slideDown(300);
    $('.fr-header').append('<p class="fr-error" id="fr-error" style="margin-top:10px;">Please enter your repair number and email address, or enter repair number and phone number.</p>')
    $('#numberfinder').focus()
    $('#numberfinder').attr('aria-describedby', 'fr-error')
    $(window).scrollTop($('.fr-header').offset().top - 400);
    return false;
  }

  if(numberVal === ''){
    $('.finderResult').slideDown(300);
    $('.fr-header').append('<p class="fr-error" id="fr-error" style="margin-top:10px;">Please also enter your repair number.</p>')
    $('#numberfinder').focus()
    $('#numberfinder').attr('aria-describedby', 'fr-error')
    $(window).scrollTop($('.fr-header').offset().top - 400);
    return false;
  }

  if(emailVal === '' && phoneVal === ''){
    $('.finderResult').slideDown(300);
    $('.fr-header').append('<p class="fr-error" id="fr-error" style="margin-top:10px;">Please also enter your phone number or email address.</p>')
    $('#emailfinder').focus()
    $('#emailfinder').attr('aria-describedby', 'fr-error')
    $(window).scrollTop($('.fr-header').offset().top - 400);
    return false;
  }

  var form_data = 'SIRA='+ numberVal +'&SIEMAIL='+ emailVal +'&SIPHONE='+ phoneVal;
  console.log(form_data);
  $('.fr-error, .fr-result').remove();
  $.ajax({
    data: form_data,
    url: "https://cgi.briggs-riley.com/cgi/CGPBLMRI1",
    method: "POST",
    dataType: "json",
    success: function(response){
      console.log(response);
      if(response.success){
        var result = response.success;
        $.each(result, function(key,val){
          var resultTable = '<div class="fr-result">'+
            '<div class="fr-resultInner">'+
              '<div class="fr-resultCol">'+
                '<table>'+
                  '<tr class="fr-repair">'+
                    '<td class="fr-dark">Repair no.</td>'+
                    '<td class="fr-light">' + val['Repair No.'] + '</td>'+
                  '</tr>'+
                  '<tr class="fr-consumer">'+
                    '<td class="fr-dark">Consumer</td>'+
                    '<td class="fr-light">' + val['Consumer'] + '</td>'+
                  '</tr>'+
                  '<tr class="fr-consumer-city">'+
                    '<td class="fr-dark">Consumer city/state</td>'+
                    '<td class="fr-light">' + val['Consumer City/State'] + '</td>'+
                  '</tr>'+
                  '<tr class="fr-consumer-phone">'+
                    '<td class="fr-dark">Consumer phone</td>'+
                    '<td class="fr-light">' + val['Consumer Phone'] + '</td>'+
                  '</tr>'+
                  '<tr class="fr-style">'+
                    '<td class="fr-dark">Style</td>'+
                    '<td class="fr-light">' + val['Style'] + '</td>'+
                  '</tr>'+
                '</table>'+
              '</div>'+
              '<div class="fr-resultCol">'+
                '<table>'+
                  '<tr class="fr-date-completed">'+
                    '<td class="fr-dark">Date completed</td>'+
                    '<td class="fr-light">' + val['Date Completed'] + '</td>'+
                  '</tr>'+
                  '<tr class="fr-statue">'+
                    '<td class="fr-dark">Status</td>'+
                    '<td class="fr-light">' + val['Status'] + '</td>'+
                  '</tr>'+
                  '<tr class="fr-tracking">'+
                    '<td class="fr-dark">Tracking</td>'+
                    '<td class="fr-light">' + val['Tracking'] + '</td>'+
                  '</tr>'+
                '</table>'+
              '</div>'+
            '</div>'+
          '</div>';
          $('.fr-header').append(resultTable);
        });
        $('.finderResult').slideDown(300);
      }else{
        $('.finderResult').slideDown(300);
        $('.fr-header').append('<p class="fr-error" style="margin-top:10px;">' + response.error.error_message + '</p>')
      }
      $(window).scrollTop($('.fr-header').offset().top - 400);
    },
    error: function (response) {
     console.log(response);
    }
  });

//     if(VisiInpVal == '') {
//       console.log('blank');
//       $('.finderInput').find('.errorInput').remove();
//       $('.finderInput').append('<span class="errorInput">Required*</span>');
//     }
//     else {
//       $('.finderInput').find('.errorInput').remove();
//       $('.finderResult').slideDown(300);
//     }
});


function statesUpdate() {
  var activeCountry = $('#rf-country').find('option:selected').val();
  //stateCountryJson();
  var states = $('#rf-country').find('option:selected').attr('data-provinces');
  if(states != '[]') {
    $('#rf-state').show();
    states = JSON.parse(states);
    var stateLen = states.length;
    $('#rf-state').find('option').remove();
    $('#rf-state').append('<option disabled>State</option>');
    for(i=0; i<stateLen;i++) {
      $('#rf-state').append('<option>'+states[i][0]+'</option>');
    }
  }
  else {
    $('#rf-state').hide();
  }
}

function contactStatesUpdate() {
  console.log('statesUpdate');
  var states = $('#cu_country').find('option:selected').attr('data-provinces');
  if(states != '[]') {
    $('#cu_state').show();
    states = JSON.parse(states);
    var stateLen = states.length;
    $('#cu_state').find('option').remove();
    $('#cu_state').append('<option>State</option>');
    for(i=0; i<stateLen;i++) {
      $('#cu_state').append('<option value="'+states[i][0]+'">'+states[i][0]+'</option>');
    }
  }
  else {
    $('#cu_state').hide();
  }
}

if($('body').hasClass('page-repair-request')) {
//     statesUpdate();
}

if($('body').hasClass('page-contact')) {
  contactStatesUpdate();
  $('input[type=file]').on('change', function() {
    var fileName = $(this).val();
    if(fileName != '') {
      var fileIndex = fileName.lastIndexOf('\\');
      if(fileIndex > 0) {
        fileName = fileName.substr(fileIndex+1);
        $('.cu-maxFile').text(fileName);
      }
    }
  });
}



//   $('#rf-country').change(function() {
//     //statesUpdate();
//   });

$('#cu_country').change(function() {
  contactStatesUpdate();
});

$('#rf-color').change(function() {
  if($(this).find('option:selected').text() != 'Color*') {
    $(this).removeClass('redBorder');
  }
});
$('#rf-state').change(function() {
  if($(this).find('option:selected').text() != 'State') {
    $(this).removeClass('redBorder');
  }
});

if($('body').hasClass('page-Submit')) {
  document.getElementById("pr-response").addEventListener("click", function() {
    var printContents = document.getElementById('pr-response').innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;

});
}